<template>
  <div
    class="font-inter w-full max-w-[1440px] mx-auto px-4 md:px-8 lg:px-12 py-6 md:py-10 overflow-x-hidden"
  >
    <div
      class="flex flex-col md:flex-row gap-6 md:gap-10 lg:gap-16 items-start"
    >
      <!-- Back Button Column -->
      <aside class="flex-shrink-0">
        <BackButton />
      </aside>

      <!-- Content Column -->
      <main class="flex-1 w-full space-y-6 md:space-y-8">
        <h1
          v-if="activeSettingsTab !== 'investment_history'"
          class="text-3xl md:text-4xl font-bold text-foreground dark:text-foreground tracking-tight"
        >
          Settings
        </h1>
        <div
          class="bg-card dark:bg-card border border-border dark:border-border p-2 md:p-8 rounded-2xl shadow-sm space-y-6 md:space-y-8"
        >
          <div class="space-y-6">
            <Tabs v-model="activeSettingsTab" class="w-full">
              <TabsList
                class="mb-6 flex flex-nowrap overflow-x-auto justify-start h-auto p-1 scrollbar-hide"
              >
                <TabsTrigger
                  v-for="tab in getSettingsTabs()"
                  :key="tab"
                  :value="tab"
                  class="whitespace-nowrap px-4 py-2"
                >
                  {{ tab }}
                </TabsTrigger>
              </TabsList>

              <TabsContent value="My Details" class=" ">
                <div class="space-y-5">
                  <div
                    class="flex flex-col md:flex-row md:justify-between md:items-center gap-4 text-muted-foreground dark:text-muted-foreground text-sm"
                  >
                    <div class="space-y-2">
                      <p
                        class="text-base font-bold text-foreground dark:text-foreground"
                      >
                        Personal Info
                      </p>
                      <p
                        class="text-muted-foreground dark:text-muted-foreground"
                      >
                        Update your photo and personal details here.
                      </p>
                    </div>

                    <div class="flex gap-3">
                      <button
                        v-if="!editMode"
                        @click="editMode = true"
                        class="py-2 px-4 bg-primary dark:bg-black hover:bg-primary/90 text-primary-foreground dark:text-secondary-foreground rounded-md transition-colors text-sm font-medium"
                      >
                        Edit
                      </button>
                      <button
                        v-if="editMode"
                        @click="cancelEdit"
                        class="py-2 px-4 border border-input hover:bg-accent hover:text-accent-foreground rounded-md transition-colors text-sm font-medium"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        v-if="editMode"
                        @click="updateUserProfile"
                        class="py-2 px-4 bg-primary dark:bg-black hover:bg-primary/90 text-primary-foreground dark:text-secondary-foreground rounded-md transition-colors text-sm font-medium"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                  <hr
                    class="w-full border-t border-border dark:border-border"
                  />

                  <div
                    class="flex flex-col md:flex-row md:items-center gap-4 md:gap-8 text-muted-foreground dark:text-muted-foreground text-sm"
                  >
                    <p
                      class="md:w-[280px] font-medium text-foreground dark:text-foreground"
                    >
                      Name
                    </p>
                    <div class="flex flex-col sm:flex-row gap-4">
                      <input
                        type="text"
                        :disabled="!editMode"
                        v-model="user.first_name"
                        placeholder="First name"
                        class="flex-1 sm:w-[244px] px-3 py-2 bg-background dark:bg-background border border-input dark:border-input rounded-md text-sm text-foreground dark:text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent disabled:opacity-50 disabled:cursor-not-allowed"
                      />
                      <input
                        type="text"
                        :disabled="!editMode"
                        v-model="user.last_name"
                        placeholder="Last name"
                        class="flex-1 sm:w-[244px] px-3 py-2 bg-background dark:bg-background border border-input dark:border-input rounded-md text-sm text-foreground dark:text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent disabled:opacity-50 disabled:cursor-not-allowed"
                      />
                    </div>
                  </div>
                  <hr
                    class="w-full border-t border-border dark:border-border"
                  />

                  <div
                    class="flex flex-col md:flex-row md:items-center gap-4 md:gap-8 text-muted-foreground dark:text-muted-foreground text-sm"
                  >
                    <p
                      class="md:w-[280px] font-medium text-foreground dark:text-foreground"
                    >
                      Email
                    </p>
                    <input
                      type="email"
                      :disabled="!editMode"
                      v-model="user.email"
                      placeholder="email@example.com"
                      class="flex-1 max-w-full md:max-w-[512px] px-3 py-2 bg-background dark:bg-background border border-input dark:border-input rounded-md text-sm text-foreground dark:text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent disabled:opacity-50 disabled:cursor-not-allowed"
                    />
                  </div>
                  <hr
                    class="w-full border-t border-border dark:border-border"
                  />
                  <div
                    class="flex flex-col md:flex-row md:items-center gap-4 md:gap-8 text-muted-foreground dark:text-muted-foreground text-sm"
                  >
                    <p
                      class="md:w-[280px] font-medium text-foreground dark:text-foreground"
                    >
                      Phone
                    </p>
                    <input
                      type="tel"
                      :disabled="!editMode"
                      v-model="user.phone"
                      placeholder="+1 (555) 000-0000"
                      class="flex-1 max-w-full md:max-w-[512px] px-3 py-2 bg-background dark:bg-background border border-input dark:border-input rounded-md text-sm text-foreground dark:text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent disabled:opacity-50 disabled:cursor-not-allowed"
                    />
                  </div>
                  <hr
                    class="w-full border-t border-border dark:border-border"
                  />

                  <div
                    class="flex flex-col md:flex-row md:items-center gap-4 md:gap-8 text-muted-foreground dark:text-muted-foreground text-sm"
                  >
                    <div class="space-y-2 md:w-[280px]">
                      <p
                        class="text-base font-bold text-foreground dark:text-foreground"
                      >
                        Your photo
                      </p>
                      <p
                        class="text-muted-foreground dark:text-muted-foreground"
                      >
                        This will be displayed on your profile
                      </p>
                    </div>
                    <div
                      class="flex flex-col sm:flex-row gap-4 flex-1 w-full overflow-hidden"
                    >
                      <!-- Profile Picture Preview -->
                      <div
                        class="flex items-center justify-center rounded-full w-16 h-16 bg-primary dark:bg-black text-primary-foreground dark:text-primary-foreground text-sm font-bold overflow-hidden flex-shrink-0 relative"
                      >
                        <img
                          v-if="profilePicture"
                          :src="profilePicture"
                          alt="Profile Picture"
                          class="object-cover w-full h-full"
                        />
                        <img
                          v-else-if="user.profile_picture"
                          :src="user.profile_picture"
                          alt="Profile Picture"
                          class="object-cover w-full h-full"
                        />
                        <!-- Compression Loading Overlay -->
                        <div
                          v-if="isCompressing"
                          class="absolute inset-0 bg-black/40 flex items-center justify-center z-10"
                        >
                          <div
                            class="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"
                          ></div>
                        </div>
                      </div>

                      <!-- Upload Section -->
                      <div
                        v-if="editMode"
                        @click="triggerFileUpload"
                        class="w-full md:max-w-[428px] min-h-[126px] border border-border dark:border-border rounded-lg py-4 px-6 flex flex-col justify-center items-center bg-muted/30 dark:bg-muted/20 space-y-2 transition-colors relative"
                        :class="
                          isCompressing
                            ? 'cursor-not-allowed opacity-50'
                            : 'cursor-pointer hover:bg-muted/50 dark:hover:bg-muted/30'
                        "
                      >
                        <div
                          class="flex items-center justify-center rounded-full w-10 h-10 bg-background dark:bg-background shadow-sm"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="h-5 w-5 text-muted-foreground"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              stroke-width="2"
                              d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                            />
                          </svg>
                        </div>
                        <span
                          class="flex flex-wrap text-sm gap-1 justify-center text-center"
                        >
                          <p
                            class="font-medium text-foreground dark:text-foreground"
                          >
                            {{
                              isCompressing
                                ? "Optimizing..."
                                : "Click to upload"
                            }}
                          </p>
                          <p
                            v-if="!isCompressing"
                            class="text-muted-foreground dark:text-muted-foreground"
                          >
                            or drag and drop
                          </p>
                        </span>
                        <p
                          class="text-xs text-muted-foreground dark:text-muted-foreground text-center"
                        >
                          SVG, PNG, JPG or GIF (max. 800x400px)
                        </p>
                      </div>

                      <!-- Hidden File Input -->
                      <input
                        ref="fileInput"
                        type="file"
                        accept="image/svg+xml, image/png, image/jpeg, image/gif"
                        class="hidden"
                        @change="handleFileUpload"
                      />
                    </div>
                  </div>
                </div>
              </TabsContent>

              <TabsContent value="Password" class=" ">
                <div class="space-y-5">
                  <div
                    class="flex flex-col md:flex-row md:justify-between md:items-center gap-4 text-muted-foreground dark:text-muted-foreground text-sm"
                  >
                    <div class="space-y-2">
                      <p
                        class="text-base font-bold text-foreground dark:text-foreground"
                      >
                        Password
                      </p>
                      <p
                        class="text-muted-foreground dark:text-muted-foreground"
                      >
                        Please enter your current password to change your
                        password.
                      </p>
                    </div>
                    <button
                      v-if="!editPasswordMode"
                      @click="editPasswordMode = true"
                      class="py-2 px-4 bg-primary hover:bg-primary/90 text-primary-foreground dark:bg-black dark:text-secondary-foreground rounded-md transition-colors text-sm font-medium self-start md:self-auto"
                    >
                      Edit
                    </button>

                    <div v-if="editPasswordMode" class="flex gap-3">
                      <button
                        @click="cancelPasswordEdit"
                        class="py-2 px-4 border border-input hover:bg-accent hover:text-accent-foreground rounded-md transition-colors text-sm font-medium"
                      >
                        Cancel
                      </button>
                      <button
                        @click="updatePassword"
                        class="py-2 px-4 bg-primary hover:bg-primary/90 text-primary-foreground dark:bg-black dark:text-secondary-foreground rounded-md transition-colors text-sm font-medium"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                  <hr
                    class="w-full border-t border-border dark:border-border"
                  />

                  <div v-if="editPasswordMode" class="space-y-5">
                    <div
                      class="flex flex-col md:flex-row md:items-center gap-4 md:gap-8 text-muted-foreground dark:text-muted-foreground text-sm"
                    >
                      <p
                        class="md:w-[280px] font-medium text-foreground dark:text-foreground"
                      >
                        Current password
                      </p>
                      <input
                        type="password"
                        v-model="currentPassword"
                        placeholder="Enter current password"
                        class="flex-1 max-w-full md:max-w-[512px] px-3 py-2 bg-background dark:bg-background border border-input dark:border-input rounded-md text-sm text-foreground dark:text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent"
                      />
                    </div>
                    <hr
                      class="w-full border-t border-border dark:border-border"
                    />
                    <div
                      class="flex flex-col md:flex-row md:items-center gap-4 md:gap-8 text-muted-foreground dark:text-muted-foreground text-sm"
                    >
                      <p
                        class="md:w-[280px] font-medium text-foreground dark:text-foreground"
                      >
                        New password
                      </p>
                      <input
                        type="password"
                        v-model="newPassword"
                        placeholder="Enter new password"
                        class="flex-1 max-w-full md:max-w-[512px] px-3 py-2 bg-background dark:bg-background border border-input dark:border-input rounded-md text-sm text-foreground dark:text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent"
                      />
                    </div>
                    <hr
                      class="w-full border-t border-border dark:border-border"
                    />
                    <div
                      class="flex flex-col md:flex-row md:items-center gap-4 md:gap-8 text-muted-foreground dark:text-muted-foreground text-sm"
                    >
                      <p
                        class="md:w-[280px] font-medium text-foreground dark:text-foreground"
                      >
                        Confirm password
                      </p>
                      <input
                        type="password"
                        v-model="confirmPassword"
                        placeholder="Confirm new password"
                        class="flex-1 max-w-full md:max-w-[512px] px-3 py-2 bg-background dark:bg-background border border-input dark:border-input rounded-md text-sm text-foreground dark:text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent"
                      />
                    </div>
                  </div>
                </div>
              </TabsContent>

              <TabsContent value="Notifications">
                <div class="flex justify-center items-center">
                  <div
                    class="space-y-2 py-12 md:py-16 bg-muted/50 dark:bg-muted/30 font-medium w-full min-h-[40vh] flex items-center justify-center rounded-lg border border-border dark:border-border"
                  >
                    <p
                      class="text-lg md:text-xl text-muted-foreground dark:text-muted-foreground"
                    >
                      Coming Soon!
                    </p>
                  </div>
                </div>

                <!-- <div class="space-y-5">
              <div
                class="flex justify-between items-center text-grayDark text-[14px]"
              >
                <div class="space-y-2">
                  <p class="text-[16px] font-bold text-primaryDarkBg">
                    Notifications
                  </p>
                  <p>
                    Enable notifications to find out what's going on when you're
                    not online. You can disable these anytime.
                  </p>
                </div>
                <div class="flex gap-3">
                  <button
                    v-if="editMode"
                    @click="cancelEdit"
                    class="py-2 px-4 border border-input hover:bg-accent hover:text-accent-foreground rounded-md transition-colors text-sm font-medium"
                  >
                    Cancel
                  </button>
                  <button
                    v-if="editMode"
                    @click="updateUser"
                    class="py-2 px-4 bg-primary hover:bg-primary/90 text-primary-foreground dark:bg-secondary dark:text-secondary-foreground rounded-md transition-colors text-sm font-medium"
                  >
                    Save
                  </button>
                </div>
              </div>
              <hr class="w-full border-t border-border dark:border-border" />
              <div class="space-y-6">
                <div class="space-y-2">
                  <p class="text-[16px] font-bold text-primaryDarkBg">
                    Comments
                  </p>
                  <p class="text-[14px] text-grayDark">
                    These are notifications for comments on your posts and
                    replies to your comments.
                  </p>
                </div>
                <div class="text-[14px] space-y-4">
                  <span class="flex space-x-2">
                    <img
                      src="@/assets/settings/Checkbox.svg"
                      alt="team"
                      class="rounded-lg"
                    />
                    <p class="font-medium text-primaryDarkBg">
                      Do not notify me
                    </p>
                  </span>
                  <div class="space-y-2">
                    <span class="flex space-x-2">
                      <img
                        src="@/assets/settings/Checkbox.svg"
                        alt="team"
                        class="rounded-lg"
                      />
                      <p class="font-medium text-primaryDarkBg">
                        Mentions only
                      </p>
                    </span>
                    <p class="text-[14px] text-grayDark ml-6">
                      Only notify me if I’m mentioned in a comment.
                    </p>
                  </div>
                  <div class="space-y-2">
                    <span class="flex space-x-2">
                      <img
                        src="@/assets/settings/Input.svg"
                        alt="team"
                        class="rounded-lg"
                      />
                      <p class="font-medium text-primaryDarkBg">All comments</p>
                    </span>
                    <p class="text-[14px] text-grayDark ml-6">
                      Notify me for all comments on my posts.
                    </p>
                  </div>
                </div>
              </div>

              <div class="space-y-6">
                <div class="space-y-2">
                  <p class="text-[16px] font-bold text-primaryDarkBg">
                    Reminders
                  </p>
                  <p class="text-[14px] text-grayDark">
                    These are notifications to remind you of updates you might
                    have missed.
                  </p>
                </div>
                <div class="text-[14px] space-y-4">
                  <span class="flex space-x-2">
                    <img
                      src="@/assets/settings/Checkbox.svg"
                      alt="team"
                      class="rounded-lg"
                    />
                    <p class="font-medium text-primaryDarkBg">
                      Do not notify me
                    </p>
                  </span>
                  <div class="space-y-2">
                    <span class="flex space-x-2">
                      <img
                        src="@/assets/settings/Checkbox.svg"
                        alt="team"
                        class="rounded-lg"
                      />
                      <p class="font-medium text-primaryDarkBg">
                        Important reminders only
                      </p>
                    </span>
                    <p class="text-[14px] text-grayDark ml-6">
                      Only notify me if the reminder is tagged as important.
                    </p>
                  </div>
                  <div class="space-y-2">
                    <span class="flex space-x-2">
                      <img
                        src="@/assets/settings/Input.svg"
                        alt="team"
                        class="rounded-lg"
                      />
                      <p class="font-medium text-primaryDarkBg">
                        All reminders
                      </p>
                    </span>
                    <p class="text-[14px] text-grayDark ml-6">
                      Notify me for all reminders.
                    </p>
                  </div>
                </div>
              </div>
            </div> -->
              </TabsContent>

              <TabsContent value="Device Settings">
                <div class="flex justify-center items-center">
                  <div
                    class="space-y-2 py-12 md:py-16 bg-muted/50 dark:bg-muted/30 font-medium w-full min-h-[40vh] flex items-center justify-center rounded-lg border border-border dark:border-border"
                  >
                    <p
                      class="text-lg md:text-xl text-muted-foreground dark:text-muted-foreground"
                    >
                      Coming Soon!
                    </p>
                  </div>
                </div>
                <!-- <div class="space-y-5">
              <hr class="w-full border-t-[1px] border-[#E5E7ED]" />
              <TabComponent
                :tabs="deviceSettingsTabs"
                v-model="activeDeviceSettingsTab"
                :compact="false"
              />
              <div
                class="space-y-6"
                v-if="activeDeviceSettingsTab === 'Active History'"
              >
                <div
                  class="flex justify-between items-center text-grayDark text-[14px]"
                >
                  <div class="space-y-2">
                    <p>
                      Active History shows the devices connected to your account
                      and the last active time.
                    </p>
                  </div>
                </div>
                <hr class="w-full border-t-[1px] border-[#E5E7ED]" />
                <div class="space-y-6">
                  <div class="flex justify-between items-center text-[14px]">
                    <div class="flex gap-2 items-center">
                      <div
                        class="flex justify-center items-center space-y-2 bg-[#E6FBE8] w-[64px] h-[64px] rounded-full"
                      >
                        <img
                          src="@/assets/settings/Vector.svg"
                          alt="desktop"
                          class="rounded-lg"
                        />
                      </div>
                      <span class="space-y-1">
                        <p class="font-medium text-[14px] text-primaryDarkBg">
                          Mac OS X Big Sur
                        </p>
                        <p class="text-[11px] text-grayDark">
                          Last Activity | Active
                        </p>
                      </span>
                    </div>
                    <p class="font-semibold text-[11px] text-grayDark">
                      Configure Device
                    </p>
                  </div>
                  <div class="flex justify-between items-center text-[14px]">
                    <div class="flex gap-2 items-center">
                      <div
                        class="flex justify-center items-center space-y-2 bg-[#E6FBE8] w-[64px] h-[64px] rounded-full"
                      >
                        <img
                          src="@/assets/settings/phone_iphone.svg"
                          alt="desktop"
                          class="rounded-lg"
                        />
                      </div>
                      <span class="space-y-1">
                        <p class="font-medium text-[14px] text-primaryDarkBg">
                          IOS 14 Iphone X
                        </p>
                        <p class="text-[11px] text-grayDark">
                          Last Activity | Active
                        </p>
                      </span>
                    </div>
                    <p class="font-semibold text-[11px] text-grayDark">
                      Configure Device
                    </p>
                  </div>
                  <div class="flex justify-between items-center text-[14px]">
                    <div class="flex gap-2 items-center">
                      <div
                        class="flex justify-center items-center space-y-2 bg-[#E6FBE8] w-[64px] h-[64px] rounded-full"
                      >
                        <img
                          src="@/assets/settings/Vector.svg"
                          alt="desktop"
                          class="rounded-lg"
                        />
                      </div>
                      <span class="space-y-1">
                        <p class="font-medium text-[14px] text-primaryDarkBg">
                          Windows 10 Dell
                        </p>
                        <span class="flex gap-1">
                          <p class="text-[11px] text-grayDark">
                            Last Activity |
                          </p>
                          <p class="text-[11px] text-grayDark">2 days ago</p>
                        </span>
                      </span>
                    </div>
                    <p class="font-semibold text-[11px] text-grayDark">
                      Configure Device
                    </p>
                  </div>
                </div>
                <p class="mt-32 text-[15px] font-medium text-grayDark">
                  Total Active Device Connected | 4
                </p>
              </div>

              <div
                class="space-y-6"
                v-if="activeDeviceSettingsTab === 'Devices & Configurations'"
              >
                <div
                  class="flex justify-between items-center text-grayDark text-[14px]"
                >
                  <div class="space-y-2">
                    <p>Device & Configurations settings.</p>
                  </div>
                </div>
                <hr class="w-full border-t-[1px] border-[#E5E7ED]" />
                <div
                  class="border border-[#F1F2F4] rounded-[12px] px-4 py-4 space-y-6"
                >
                  <div class="flex justify-between items-center text-[14px]">
                    <div class="flex gap-2 items-center">
                      <span class="flex space-x-1">
                        <img
                          src="@/assets/settings/Vector.svg"
                          alt="desktop"
                          class="w-[18px] h-[18px] rounded-lg"
                        />
                        <p class="font-medium text-[14px] text-primaryDarkBg">
                          Mac OS X Big Sur
                        </p>
                      </span>
                    </div>
                    <p class="font-semibold text-[11px] text-grayDark">
                      Configure Device
                    </p>
                  </div>
                  <div class="flex flex-wrap items-center gap-2 mt-4">
                    <span
                      v-for="(social, index) in socials"
                      :key="index"
                      class="flex items-center px-2 py-1 bg-[#F1F2F4] text-grayDark text-[13px] border border-grayLight rounded-full cursor-pointer"
                    >
                      {{ social }}
                      <button @click.prevent="removeSocial(index)" class="ml-2">
                        <img
                          src="@/assets/dashboard/iconoir_cancel.svg"
                          alt="Close"
                          class="w-4 h-4"
                        />
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            </div> -->
              </TabsContent>
              <TabsContent v-if="isInvestor" value="investment_history">
                <div class="space-y-5">
                  <div
                    class="flex flex-col md:flex-row md:justify-between md:items-center gap-4 text-muted-foreground dark:text-muted-foreground text-sm"
                  >
                    <div class="space-y-2">
                      <p
                        class="text-2xl font-bold text-foreground dark:text-foreground"
                      >
                        Investment History
                      </p>
                      <p
                        class="text-muted-foreground dark:text-muted-foreground"
                      >
                        See all your investment references from Past to Present.
                      </p>
                    </div>
                    <div class="flex gap-3">
                      <button
                        v-if="editMode"
                        @click="cancelEdit"
                        class="py-2 px-4 border border-input hover:bg-accent hover:text-accent-foreground rounded-md transition-colors text-sm font-medium"
                      >
                        Cancel
                      </button>
                      <button
                        v-if="editMode"
                        @click="updateUser"
                        class="py-2 px-4 bg-primary hover:bg-primary/90 text-primary-foreground dark:bg-black dark:text-secondary-foreground rounded-md transition-colors text-sm font-medium"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                  <hr
                    class="w-full border-t border-border dark:border-border"
                  />

                  <div
                    class="overflow-x-auto rounded-lg border border-border dark:border-border scrollbar-hide"
                  >
                    <div
                      v-if="invested_projects.length === 0"
                      class="text-center py-16 text-muted-foreground"
                    >
                      No history yet.
                    </div>
                    <div v-else>
                      <table class="min-w-full divide-y divide-border">
                        <thead class="bg-muted/50 text-muted-foreground">
                          <tr>
                            <th
                              scope="col"
                              class="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                            >
                              Project Name
                            </th>
                            <th
                              scope="col"
                              class="px-6 py-3 text-left tracking-wider"
                            >
                              Amount Invested
                            </th>
                            <th
                              scope="col"
                              class="px-6 py-3 text-left tracking-wider"
                            >
                              Payment Status
                            </th>
                            <th
                              scope="col"
                              class="px-6 py-3 text-left tracking-wider"
                            >
                              Reference
                            </th>
                            <th
                              scope="col"
                              class="px-6 py-3 text-left tracking-wider"
                            >
                              Date
                            </th>
                          </tr>
                        </thead>
                        <tbody class="bg-white divide-y text-bodyText">
                          <tr
                            v-for="project in projects"
                            :key="project.project_id"
                            @click="goToProject(project.project_id)"
                            class="mb-2 cursor-pointer text-[13px]"
                          >
                            <td
                              class="px-4 py-4 font-semibold whitespace-nowrap"
                            >
                              {{ project.project_name }}
                            </td>
                            <td class="px-4 py-4 whitespace-nowrap">
                              <div v-if="isAdmin" class="flex items-center">
                                <div
                                  class="relative w-[124px] h-[9px] bg-[#F3F4F6] rounded-full overflow-hidden"
                                >
                                  <div
                                    class="absolute top-0 left-0 h-full bg-primaryDark rounded-full"
                                    :style="{ width: `${project.progress}%` }"
                                  ></div>
                                </div>
                                <span class="ml-2 text-[12px] font-medium"
                                  >{{ project.progress }}%</span
                                >
                              </div>
                              <div v-else class="flex items-center">
                                <div
                                  class="relative w-[124px] h-[9px] bg-[#F3F4F6] rounded-full overflow-hidden"
                                >
                                  <!-- Inner progress bar -->
                                  <div
                                    class="absolute top-0 left-0 h-full bg-primaryDark rounded-full"
                                    :style="{
                                      width: `${project.project_progress}%`,
                                    }"
                                  ></div>
                                </div>
                                <span class="ml-2 text-[12px] font-medium"
                                  >{{ project.project_progress }}%</span
                                >
                              </div>
                            </td>
                            <td class="px-4 py-4 whitespace-nowrap">
                              <div
                                v-if="project.project_status === 'Active'"
                                class="flex items-center gap-2 py-1 px-2 rounded-full bg-[#EBF1FF] text-primaryDarkBg"
                              >
                                <div
                                  class="w-2 h-2 bg-primaryDarkBg rounded-full"
                                ></div>
                                {{ project.project_status }}
                              </div>
                              <div
                                v-else-if="
                                  project.project_status === 'Not Started'
                                "
                                class="flex items-center gap-2 py-1 px-2 rounded-full bg-[#FFF5E6] text-pendingStatus"
                              >
                                <div
                                  class="w-2 h-2 bg-pendingStatus rounded-full"
                                ></div>
                                {{ project.project_status }}
                              </div>
                              <div
                                v-else-if="
                                  project.project_status === 'Completed'
                                "
                                class="flex items-center gap-2 py-1 px-2 rounded-full bg-[#EBFFEB] text-completedStatus"
                              >
                                <div
                                  class="w-2 h-2 bg-completedStatus rounded-full"
                                ></div>
                                {{ project.project_status }}
                              </div>
                              <div
                                v-else
                                class="flex items-center gap-2 py-1 px-2 rounded-full bg-[#EBF1FF] text-primaryDarkBg"
                              >
                                <div
                                  class="w-2 h-2 bg-primaryDarkBg rounded-full"
                                ></div>
                                {{ project.status }}
                              </div>
                            </td>

                            <td class="px-4 py-4 whitespace-nowrap">
                              <div
                                v-if="isAdmin"
                                class="flex items-center rounded-[8px] text-grayDark font-medium gap-2"
                              >
                                <img
                                  src="@/assets/projects/task-square.svg"
                                  alt="team"
                                  class="h-4 overlap"
                                />
                                {{ formatDate(project.end_date) }}
                              </div>
                              <div
                                v-else
                                class="flex items-center rounded-[8px] text-grayDark font-medium gap-2"
                              >
                                <img
                                  src="@/assets/projects/task-square.svg"
                                  alt="team"
                                  class="h-4 overlap"
                                />
                                {{ formatDate(project.project_end_date) }}
                              </div>
                            </td>

                            <td class="px-4 py-4 whitespace-nowrap">
                              <div class="flex items-center gap-2">
                                <span
                                  >{{ project.completedTasks || 0 }} /
                                  {{ project.totalTasks || 0 }}</span
                                >
                              </div>
                            </td>
                            <td class="px-4 py-4 whitespace-nowrap">
                              <button
                                @click="goToProjectAssets(project.project_id)"
                                class="transition flex items-center gap-4 underline"
                              >
                                View details
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <PaginationComponent
                    :currentPage="currentPage"
                    :totalPages="totalPages"
                    @changePage="handlePageChange"
                  />
                </div>
              </TabsContent>
            </Tabs>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import apiClient from "@/axios";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import BackButton from "../BackButton.vue";
import imageCompression from "browser-image-compression";

export default {
  name: "SettingsComponent",
  components: {
    Tabs,
    TabsContent,
    TabsList,
    TabsTrigger,
    BackButton,
  },
  data() {
    return {
      socials: ["Whatsapp", "Twitter", "Facebook", "LinkedIn", "Instagram"],
      invested_projects: [],
      profilePicture: null, // Holds the temporary picture URL for preview
      originalProfilePicture: null, // Store the DB profile picture
      temporaryFile: null, // To hold the raw file data for upload
      talentId: null,
      userId: null,
      editMode: false,
      editPasswordMode: false,
      user: {
        user_id: "",
        first_name: "",
        last_name: "",
        email: "",
        role: "",
        phone: "",
      },
      editUser: {},
      loading: true,
      activeSettingsTab: "",
      isCompressing: false,
      activeDeviceSettingsTab:
        localStorage.getItem("activeDeviceSettingsTab") || "Active History",

      deviceSettingsTabs: ["Active History", "Devices & Configurations"],

      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isManager() {
      return this.$store.getters.isManager;
    },
    isTalent() {
      return this.$store.getters.isTalent;
    },
    isInvestor() {
      return this.$store.getters.isInvestor;
    },
    isUser() {
      return this.$store.getters.isTalent;
    },
    fullName() {
      if (
        !this.talent ||
        (!this.talent.talent_first_name && !this.talent.talent_last_name)
      ) {
        return "";
      }
      return `${this.talent.talent_first_name || ""} ${
        this.talent.talent_last_name || ""
      }`.trim();
    },
    userIdentifier() {
      return this.user?.user_id || this.$store.state.user?.user_id || "default";
    },
  },
  watch: {
    // '$route.query.section': {
    //   immediate: true,
    //   handler(newSection) {
    //     const validTabs = ['My Details', 'password', 'Notifications', 'Device Settings', 'Investment History'];
    //     if (validTabs.includes(newSection)) {
    //       this.activeSettingsTab = newSection;
    //     } else {
    //       this.activeSettingsTab = 'My Details'; // Default to 'my_details'
    //     }
    //     localStorage.setItem('activeSettingsTab', newSection);
    //   },
    // },
  },
  methods: {
    removeSocial(index) {
      this.socials.splice(index, 1);
    },
    setActiveTab(tab) {
      console.log("Setting active tab to:", tab);
      this.activeSettingsTab = tab;
    },

    // Get available main tabs based on user role
    getAvailableMainTabs() {
      let tabs = ["My Details", "Password", "Notifications", "Device Settings"];

      // Add investment history tab for investors
      if (this.isInvestor) {
        tabs.push("investment_history");
      }

      return tabs;
    },

    // Update the settingsTabs computed property or data
    getSettingsTabs() {
      return this.getAvailableMainTabs();
    },
    updateRouteQuery(tab) {
      this.$router
        .push({
          name: "Settings",
          query: { section: tab },
        })
        .catch(() => {}); // Catch navigation duplicated error
    },
    triggerFileUpload() {
      this.$refs.fileInput.click();
    },

    async handleFileUpload(event) {
      const file = event.target.files[0];
      if (!file) return;

      this.isCompressing = true;
      try {
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 1024,
          useWebWorker: true,
        };

        const compressedFile = await imageCompression(file, options);
        this.profilePicture = URL.createObjectURL(compressedFile);
        this.temporaryFile = compressedFile;
        console.log("Selected and compressed file:", compressedFile);
      } catch (error) {
        console.error("Compression error:", error);
      } finally {
        this.isCompressing = false;
      }
    },

    async uploadProfilePicture() {
      if (!this.temporaryFile) {
        console.error("No file selected.");
        return;
      }
      console.log(`Uploading profile picture for user ID: ${this.userId}`);
      const formData = new FormData();
      formData.append("file", this.temporaryFile);

      try {
        const response = await apiClient.post(
          `/web/upload_profile_picture/${this.userId}`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          },
        );
        console.log("Upload successful:", response.data);
        this.temporaryFile = false; // Reset the file
        this.fetchProfilePicture();
      } catch (error) {
        console.error("Error uploading picture:", error);
      }
    },
    async fetchProfilePicture() {
      try {
        const response = await apiClient.post("/current_user/");
        if (response.data.user.profile_picture) {
          this.profilePicture = response.data.user.profile_picture;
        }
      } catch (error) {
        console.error("Error fetching profile picture:", error);
      }
    },
    async updateUserProfile() {
      try {
        const userId = this.userId;
        await apiClient.put(`/web/users/${userId}`, {
          first_name: this.user.first_name,
          last_name: this.user.last_name,
          email: this.user.email,
          phone: this.user.phone || "",
          role: this.user.role,
        });
        this.editMode = false; // Exit edit mode
        // this.closeSideMenu()

        this.successMessage = "User updated successfully"; // Set the success message
        this.showSuccess = true;
      } catch (error) {
        console.error("Error updating user:", error);
      }
    },

    capitalize(text) {
      if (!text) return "";
      return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
    },

    async fetchUserData() {
      try {
        const response = await apiClient.post("/current_user");
        this.user = response.data.user;
        this.userId = response.data.user.user_id;
        this.editUser = { ...this.user }; // Clone user data for editing
        console.log("fetched user data:", this.user);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    },
    async updateUser() {
      try {
        if (this.isAdmin) {
          const userId = this.$route.params.userId;
          const response = await apiClient.put(
            `/web/users/${userId}`,
            this.editUser,
          );
          this.user = response.data.data;
          this.editMode = false;
          this.editPasswordMode = false;

          console.log("User updated:", response.data.data);
        }
      } catch (error) {
        console.error("Error updating user:", error);
      }
    },
    cancelEdit() {
      this.editUser = { ...this.user }; // Revert changes
      this.editMode = false;
    },
    cancelPasswordEdit() {
      this.editUser = { ...this.user }; // Revert changes
      this.editPasswordMode = false;
    },
    async fetchInvestedProjects() {
      try {
        if (this.isInvestor) {
          const response = await apiClient.get(`/web/investor/me`);

          const investorData = response.data.data;
          this.invested_projects = investorData.projects || [];
          const meta = response.data.meta;
          this.currentPage = meta.current_page;
          this.totalPages = meta.total_pages;
          this.loading = false;
        }
      } catch (error) {
        console.error("Error fetching projects:", error);
      } finally {
        this.loading = false;
      }
    },
    async updatePassword() {
      try {
        if (
          !this.currentPassword ||
          !this.newPassword ||
          !this.confirmPassword
        ) {
          alert("All fields are required.");
          return;
        }

        if (this.newPassword !== this.confirmPassword) {
          alert("New password and confirm password do not match.");
          return;
        }

        const payload = {
          current_password: this.currentPassword,
          new_password: this.newPassword,
        };

        const response = await apiClient.put("/web/change_password", payload);

        if (response.status === 200) {
          alert("Password changed successfully.");
          this.editPasswordMode = false;
          this.currentPassword = "";
          this.newPassword = "";
          this.confirmPassword = "";
        } else {
          alert(response.data.message || "Failed to change password.");
        }
      } catch (error) {
        console.error(
          "Error updating password:",
          error.response?.data || error,
        );
        alert("An error occurred while changing the password.");
      }
    },
  },
  created() {
    // Set default tab
    const section = this.$route.query.section;
    if (section && this.getAvailableMainTabs().includes(section)) {
      this.activeSettingsTab = section;
    } else {
      this.activeSettingsTab = "My Details";
    }

    this.fetchUserData();
  },

  beforeUnmount() {
    // Clean up both storage listeners
    if (this.mainTabStorageListener) {
      window.removeEventListener("storage", this.mainTabStorageListener);
    }
    if (this.deviceTabStorageListener) {
      window.removeEventListener("storage", this.deviceTabStorageListener);
    }
  },
};
</script>

<style scoped>
/* Add your styles here */
</style>
